var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mx-2"},[_c('v-col',{style:({ 'padding-left': _vm.padding })},[_c('div',{},[_c('CardsView',{staticClass:"mt-5",attrs:{"items":_vm.items,"openDialog":_vm.openDialog,"title":_vm.title,"showAdd":false,"showDelete":false,"showEdit":false},on:{"goToItem":_vm.goToItem}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }